export const GET_ADMIN_LIST = "GET_ADMIN_LIST";
export const GET_USER_GROUP = "GET_USER_GROUP";
export const POST_ADMIN = "POST_ADMIN";
export const SHOW_ADMIN = "SHOW_ADMIN";
export const UPDATE_ADMIN = "UPDATE_ADMIN";
export const DELETE_ADMIN = "DELETE_ADMIN";
export const UPDATE_STATUS_ADMIN = "UPDATE_STATUS_ADMIN";
export const DROPDOWN = "ADMIN_DROPDOWN";